
import { BaseModel } from "./base/base.model";

export class AppAnuncios extends BaseModel {
  announcement1?: string;
  title?: string;
  content?: string;
  status?: string;
  publisher?: string;
  publisherData?: { name: string, publisher1: string };
  published?: string;
  publishedOn?: string;
  createdAt?: string;
  modifiedOn?: string;
  companies?: [{ name: string, company1: string }];
  userViews?: [{ userId: string, userName: string, viewedAt: string, companyData: { company1: string, name: string } }];
}
